<div class="row">
    <div class="col-10 text-left" style="margin-top: -32px;padding-left: 50px;">
        <img src="/assets/img/texto-llamado.png" />
    </div>
    <div class="col-2 text-center">
        <img src="/assets/img/logo-header.svg" style="margin-top:10px;height: 80px;" />

    </div>
</div>
